import { defineComponent, ref, onMounted, computed } from 'vue';
import { Stemdoer } from '@/shared/model/stemdoer.model';
import SAvatarStemdoer from '@/components/stemdo-components/s-avatar-stemdoer/SAvatarStemdoer.vue';
import { Certification, ICertification } from '@/shared/model/certification.model';
import { IRate } from '@/shared/model/rate.model';
import Sbutton from '@/components/stemdo-components/s-button/SButton.vue';
import { useI18N } from '@/plugins/i18n';
import { StemdoerStatus } from '@/shared/model/enumerations/stemdoer-status.model';
import StemdoerDetail from '@/sections/shared/stemdoer-detail/StemdoerDetail.vue';
import { ILanguage } from '@/shared/model/language.model';

export default defineComponent({
  props: {
    stemdoer: {
      type: Object as () => Stemdoer,
      required: true
    },
    addStemdoerToCart: {
      type: Function,
      required: true
    },
    rates: {
      type: Array as () => IRate[],
      required: true
    },
    openStemdoerDetailModal: {
      type: Function,
      required: true
    }
  },
  components: {
    SAvatarStemdoer,
    StemdoerDetail,
    Sbutton
  },
  setup(props) {
    const i18n = useI18N();
    const mutableStemdoer = ref<Stemdoer>(props.stemdoer);
    const isLoaded = ref(false);
    const uniqueCertifications = ref<{ [key: string]: string }>({});

    onMounted(() => {
      badgesFormatter();
      certificationFormatter();
    });

    const resetOverflow = () => {
      document.documentElement.style.overflow = 'auto';
    };

    const addToCart = (stemdoer: Stemdoer) => {
      if (stemdoer.canBeAddedToCart) {
        props.addStemdoerToCart(stemdoer.id);
      }
    };

    const certificationFormatter = () => {
      isLoaded.value = false;
      mutableStemdoer.value['certifications'].forEach((certification: ICertification) => {
        if (certification['validation'] == true) {
          const url = Certification.getCertificationImgUrlByName(certification['name']);
          certification['imgUrl'] = url;
          uniqueCertifications[certification['name']] = certification['imgUrl'];
        }
      });
      isLoaded.value = true;
    };

    const formatBadges = technologyScores => {
      const badgesSkills = technologyScores.slice(0, 5).map(tech => ({
        id: tech.idTechnology,
        technology: i18n.t(`technologyMaster.list.${tech.idTechnology}`),
        skill: tech.score
      }));

      badgesSkills.sort((a, b) => b.skill - a.skill || a.id - b.id);

      return badgesSkills;
    };

    const badgesFormatter = () => {
      mutableStemdoer.value['badgesSkills'] = formatBadges(mutableStemdoer.value['technologyScores']);
      isLoaded.value = true;
    };

    const getCertification = () => {
      mutableStemdoer.value['certifications'].forEach((certification: ICertification) => {});
      return mutableStemdoer.value['certifications'].filter(certification => {
        return certification['imgUrl'] != '';
      });
    };

    const hasValidEnglishLevel = computed(() => {
      const englishLanguage = (mutableStemdoer.value.languages as ILanguage[])?.find((lang: ILanguage) => lang.name === 'English');
      const englishLevel = englishLanguage ? englishLanguage.level : '';
      return ['B1', 'B2', 'C1', 'C2'].includes(englishLevel);
    });

    return {
      mutableStemdoer,
      isLoaded,
      StemdoerStatus,
      addToCart,
      getCertification,
      resetOverflow,
      Certification,
      hasValidEnglishLevel
    };
  }
});
